import { render, staticRenderFns } from "./AddShipmentGovtModal.vue?vue&type=template&id=c8359786&"
import script from "./AddShipmentGovtModal.vue?vue&type=script&lang=js&"
export * from "./AddShipmentGovtModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports